import {IconSizeColorProps} from "./types";

export default function InputLengthIcon({
    size=12,
    color="#B6B6B6",
    ...props
                                        }:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.10097 12L12 1.10097L10.899 0L0 10.899L1.10097 12ZM7.19277 11.4594L11.6684 6.98378L10.5675 5.88281L6.0918 10.3585L7.19277 11.4594Z"
              fill={color}/>
    </svg>

}